import React from 'react';
import CheckBox from '../Shared/CheckBox';
import { MultiFilters } from '../types';


const Color = (props: MultiFilters) => {
  const {
    filterData,
    handleFilterChange,
    activeFilters,
  } = props;
  const { data = [] } = filterData || {};
  return (
    <div>
      {
        data?.map(item => {
          const isSelected = (Array.isArray(activeFilters) && activeFilters.some(color => color.id == item.id));
          return ( <CheckBox key={`chk_${item.id}`} isColor data={item} handleFilterChange={handleFilterChange} isSelected={isSelected} /> );
        })
      }
    </div>
  );
};

export default Color;
